
export const GENERATE_MONITORING_PPT_REQUEST = "GENERATE_MONITORING_PPT_REQUEST";
export const GENERATE_MONITORING_PPT_SUCCESS = "GENERATE_MONITORING_PPT_SUCCESS";
export const GENERATE_MONITORING_PPT_FAIL = "GENERATE_MONITORING_PPT_FAIL";
export const GENERATE_MONITORING_PPT_RESET = "GENERATE_MONITORING_PPT_RESET";

export const GET_MONITORING_PPT_JOB_STATUS_REQUEST = "GET_MONITORING_PPT_JOB_STATUS_REQUEST";
export const GET_MONITORING_PPT_JOB_STATUS_SUCCESS = "GET_MONITORING_PPT_JOB_STATUS_SUCCESS";
export const GET_MONITORING_PPT_JOB_STATUS_FAIL = "GET_MONITORING_PPT_JOB_STATUS_FAIL";
export const GET_MONITORING_PPT_JOB_STATUS_RESET = "GET_MONITORING_PPT_JOB_STATUS_RESET";

export const CAMPAIGN_MONITORING_PICS_REQUEST =
  "CAMPAIGN_MONITORING_PICS_REQUEST";
export const CAMPAIGN_MONITORING_PICS_SUCCESS =
  "CAMPAIGN_MONITORING_PICS_SUCCESS";
export const CAMPAIGN_MONITORING_PICS_FAIL = "CAMPAIGN_MONITORING_PICS_FAIL";
